import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import { Button } from "primereact/button";
//import FilledFormPreviewDialog from "./FilledFormPreviewDialog";
import JsonDialog from "./JsonDialog";

const FilledFormsListDatatableComponent = ({
  data,
  filters,
  setFilters,
  header,
  loading,
  first,
  rows,
  totalRecords,
  onPageChange,
  onSort,
  sortField,
  sortOrder,
}) => {
  // eslint-disable-next-line
  const [selectedForm, setSelectedForm] = useState(null);
  // eslint-disable-next-line
  const [dialogVisible, setDialogVisible] = useState(false);
  const [jsonDialogVisible, setJsonDialogVisible] = useState(false);
  const [jsonForm, setJsonForm] = useState(null);
  // eslint-disable-next-line
  {
    /* const viewForm = (rowData) => {
    setSelectedForm(rowData);
    setDialogVisible(true);
  }; */
  }
  const viewJson = (rowData) => {
    setJsonForm(rowData);
    setJsonDialogVisible(true);
  };

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(date);
  };

  return (
    <div className="table-container">
      {loading ? (
        <div className="loader-container">
          <ProgressSpinner />
        </div>
      ) : (
        <>
          <DataTable
            style={{ fontFamily: "poppins" }}
            value={data}
            paginator={false}
            responsiveLayout="scroll"
            filters={filters}
            globalFilterFields={[
              "label",
              "formTitle",
              "createdAt",
              "submissionId",
            ]}
            header={header}
            emptyMessage="No forms found."
            onFilter={(e) => setFilters(e.filters)}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
          >
            <Column
              field="label"
              header="Collection Name"
              style={{ width: "25%" }}
              sortable
            ></Column>
            <Column
              field="formTitle"
              header="Form Title"
              body={(rowData) => rowData.formTitle || "N/A"}
              style={{ width: "25%" }}
              sortable
            ></Column>
            <Column
              field="submissionId"
              header="Submitted By"
              body={(rowData) =>
                rowData.submissionId ? rowData.submissionId : "Anonymous"
              }
              style={{ width: "15%" }}
              sortable
            ></Column>
            <Column
              field="createdAt"
              header="Submitted At"
              body={(rowData) => formatDate(rowData.createdAt)}
              style={{ width: "25%" }}
              sortable
            ></Column>
            <Column
              header="Actions"
              body={(rowData) => (
                <div className="actions">
                  {/* <Button
                    icon="pi pi-eye"
                    className="p-button p-button-info mr-2"
                    style={{
                      backgroundColor: "#fff",
                      color: "#0d2e4d",
                      border: "none",
                      transition: "border 0.3s ease",
                    }}
                    onClick={() => viewForm(rowData)}
                  />  */}
                  <Button
                    icon="pi pi-code"
                    className="p-button p-button-info mr-2"
                    style={{
                      backgroundColor: "#fff",
                      color: "#0d2e4d",
                      border: "none",
                      transition: "border 0.3s ease",
                    }}
                    onClick={() => viewJson(rowData)}
                  />
                </div>
              )}
              style={{ width: "25%" }}
            ></Column>
          </DataTable>
          <Paginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
          ></Paginator>
        </>
      )}
      {/*  <FilledFormPreviewDialog
        visible={dialogVisible}
        onHide={() => setDialogVisible(false)}
        form={selectedForm}
      />*/}

      <JsonDialog
        visible={jsonDialogVisible}
        onHide={() => setJsonDialogVisible(false)}
        jsonForm={jsonForm}
      />
    </div>
  );
};

export default FilledFormsListDatatableComponent;
